import { render, staticRenderFns } from "./PostV3.vue?vue&type=template&id=0bce42ce&"
import script from "./PostV3.vue?vue&type=script&lang=js&"
export * from "./PostV3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jlamb/repos/roll20/d20app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bce42ce')) {
      api.createRecord('0bce42ce', component.options)
    } else {
      api.reload('0bce42ce', component.options)
    }
    module.hot.accept("./PostV3.vue?vue&type=template&id=0bce42ce&", function () {
      api.rerender('0bce42ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/blog-preview/src/components/Posts/PostV3.vue"
export default component.exports